/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ReviewSummaryView.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'

const frenchMonthAbbr = {
  Jan: 'janv.',
  Feb: 'févr.',
  Mar: 'mars',
  Apr: 'avr.',
  May: 'mai.',
  Jun: 'juin.',
  Jul: 'juill.',
  Aug: 'août.',
  Sep: 'sept.',
  Oct: 'oct.',
  Nov: 'nov.',
  Dec: 'déc.',
}

const ContactInformationSummary = ({ t, i18n, setIsError }) => {
  let history = useHistory()

  const { email, phoneNumber, fullName, dateOfBirth, socialInsuranceNumber } = useSelector((state) => state.app.contactInformation)
  const { payeeContactInformation } = useSelector((state) => state.app)
  useEffect(() => {
    try {
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [email, phoneNumber, setIsError])

  const editContactInfoOnClick = () => {
    try {
      history.push(`/${i18n.language}${t('routes.contact_information')}?isSummary=true`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const displaySIN = useMemo(() => `XXX XXX ${socialInsuranceNumber.substr(-3)}`, [socialInsuranceNumber])
  const displayDateOfBirth = useMemo(() => {
    const formattedDOB = moment(dateOfBirth).format('DD-MMM-YYYY')
    if (i18n.language === 'en') {
      return formattedDOB
    }

    const [day, month, year] = formattedDOB.split('-')
    return `${day} ${frenchMonthAbbr[month]} ${year}`
  }, [dateOfBirth, i18n.language])

  return (
    <Fragment>
      <div className="row" style={{ marginTop: '-20px' }}>
        <div className="col-xs-12 col-md-8">
          <h2>{t('contact_information.contact_info_title')}</h2>
        </div>
        <div className="button-group">
          <button className="edit-button" onClick={editContactInfoOnClick} value={t('shared.edit')} name={t('shared.edit')}>
            {t('shared.edit')}
          </button>
        </div>
      </div>
      {payeeContactInformation && (
        <div className="row row-even">
          <div className="col-xs-6">
            <strong>{t('contact_information.debtor')}</strong>
          </div>
          <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}></div>
        </div>
      )}
      <div className="row row-odd">
        <div className="col-xs-6">
          <strong>{t('contact_information.full_name')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {fullName}
        </div>
      </div>
      <div className="row row-even">
        <div className="col-xs-6">
          <strong>{t('contact_information.social_insurance_number')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {displaySIN}
        </div>
      </div>
      <div className="row row-odd">
        <div className="col-xs-6">
          <strong>{t('contact_information.phone_number')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {phoneNumber}
        </div>
      </div>
      <div className="row row-even">
        <div className="col-xs-6">
          <strong>{t('contact_information.date_of_birth_title')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {displayDateOfBirth}
        </div>
      </div>
      <div className="row row-odd">
        <div className="col-xs-6">
          <strong>{t('contact_information.email')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {email}
        </div>
      </div>
      {payeeContactInformation && (
        <Fragment>
          <br />
          <div className="row row-odd">
            <div className="col-xs-6">
              <strong>{t('contact_information.payee')}</strong>
            </div>
            <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}></div>
          </div>
          <div className="row row-even">
            <div className="col-xs-6">
              <strong>{t('contact_information.full_name')}</strong>
            </div>
            <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
              {payeeContactInformation.fullName}
            </div>
          </div>
          <div className="row row-odd">
            <div className="col-xs-6">
              <strong>{t('contact_information.phone_number')}</strong>
            </div>
            <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
              {payeeContactInformation.phoneNumber}
            </div>
          </div>
          <div className="row row-even">
            <div className="col-xs-6">
              <strong>{t('contact_information.email')}</strong>
            </div>
            <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
              {payeeContactInformation.email}
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  )
}

export default withTranslation('common')(ContactInformationSummary)
